import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { executeOrderingRequest, OrderingError } from 'components/ordering/executor.js'
import { StopViewBasketForSalesCenterUser } from '@cloudsuite/cs-ordering-defs'


export const OPEN_BASKET_STOP_EDITING_BUTTON_API = Symbol('OPEN_BASKET_STOP_EDITING_BUTTON_API')

export interface StopViewBasketSuccess {
  success: boolean
}

export interface OpenBasketStopEditingButtonAPI {
  stopViewBasket(basketId: string): Promise<StopViewBasketSuccess>;
}


@registerDependency(REAL, OPEN_BASKET_STOP_EDITING_BUTTON_API)
export class RealOpenBasketStopEditingButtonAPI implements OpenBasketStopEditingButtonAPI {
  async stopViewBasket(basketId: string): Promise<StopViewBasketSuccess> {
    try {
      await executeOrderingRequest(new StopViewBasketForSalesCenterUser(basketId))
    } catch (error) {
      if (error instanceof OrderingError) return { success: false }
      throw error
    }

    return { success: true }
  }
}


@registerDependency(FAKE, OPEN_BASKET_STOP_EDITING_BUTTON_API)
export class FakeOpenBasketStopEditingButtonAPI implements OpenBasketStopEditingButtonAPI {
  apiSuccess = true

  setApiSuccess(success: boolean) {
    this.apiSuccess = success
  }

  async stopViewBasket(basketId: string): Promise<StopViewBasketSuccess> {
    alert('Fake API called: stopViewBasket, basketId: ' + basketId + ', apiSuccess: ' + this.apiSuccess)

    return Promise.resolve({
      success: this.apiSuccess
    })
  }
}
